import "@mapbox/mapbox-gl-draw/dist//mapbox-gl-draw.css";
import AsyncCreatableSelect from "react-select/async-creatable";
import _ from "lodash";
import mapboxgl from "mapbox-gl";
import moment from "moment";
import { browserHistory } from "react-router";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Datetime from "react-datetime";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { bindActionCreators } from "redux";
import * as actionCreators from "./actionCreator";
import { smallSelectStyle } from "../../../assets/js/select-style";
import confirm from "../../../Components/Common/ConfirmAert";
import { ROUTING_LABELS } from "../../tms/constant";
import {
  IconAt,
  IconCalendar,
  IconCheck,
  IconDownloadAlt,
  IconDrag,
  IconFlag,
  IconLoadCartLeft,
  IconLoadCartRight,
  IconMapMarkerLoad,
  IconNoteArrowRight,
  IconPhone,
  IconPlus,
  IconReturn,
  IconTimes,
  IconTrash,
  IconUploadAlt,
  IconNotes,
  IconPool
} from "../../../Components/Common/Icons";
import { LoaderBar } from "../../../Components/Common/LoaderBar";
import { getLoadRoute } from "../../../Components/CustomerServiceSideBar/actions";
import configuration from "../../../config/index";
import {
  getCarrierByUserId,
  getStorage,
  isMilitaryTime,
  makeOptionsForSelect,
  toastr
} from "../../../services/Common.services";
import {
  getChassisPickCustomers,
  getChassisTerminationCustomers,
  getDefaultAddress,
  getDroppedCustomers,
  getEmptyOriginCustomers,
  getTMSconsignee,
  getTMSshipper,
  hardRemoveDriver,
  getTMSChassis
} from "../Dispatcher/actionCreators";
import {
  removeStatusDriverOrderById,
  setLoadStatusOrder,
  uncompleteLoad,
  updateDriverOrderById,
  removeBobtailDriverPay,
  updateLoadCompletedDate
} from "./actionCreator";
import StreetTurn from "./StreetTurn";
import "./style.css";
import { manualDriverPay, UpdatePricing, saveLoadNotes, removeValueLoad } from './../../tms/services'
import ReactTooltip from "react-tooltip";
import { streetTile } from "../../trucker/NewTrack1/utility";
import RecommendedReturnTerminals from "./RecommendedReturnTerminals";

const ICONS = {
  CHASSISPICK: <IconLoadCartRight className="mr-10" />,
  PULLCONTAINER: <IconNoteArrowRight className="mr-10" />,
  DELIVERLOAD: <IconMapMarkerLoad className="mr-10" />,
  RETURNCONTAINER: <IconReturn className="mr-10" />,
  DROPCONTAINER: <IconDownloadAlt className="mr-10" />,
  HOOKCONTAINER: <IconUploadAlt className="mr-10" />,
  CHASSISTERMINATION: <IconLoadCartLeft className="mr-10" />,
  COMPLETED: <IconFlag className="mr-10" />,
};
const polyline = require("@mapbox/polyline");
mapboxgl.accessToken = configuration.map_box_api_key;
let routePoints = [];
const colors = [
  "#e87676",
  "#d4cc37",
  "#91c21f",
  "#0b9914",
  "#71e3cc",
  "#427ae3",
  "#27247d",
  "#ae4dbd",
  "#d13689",
  "#d90b2d",
];
var geojson = {
  type: "geojson",
  data: {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: [],
    },
  },
};

let freeze = false; //mark delay
let timer; //saved timer

const getChassisPickCustomersAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getChassisPickCustomers(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const getTMSshipperAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getTMSshipper(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const getTMSconsigneeAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getTMSconsignee(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const getEmptyOriginCustomersAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getEmptyOriginCustomers(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const getDroppedCustomersAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getDroppedCustomers(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const getChassisTerminationCustomersAsyncSearch = async (strSearch) => {
  freeze = true; //set mark for stop calls
  return new Promise(async (res, err) => {
    //return promise
    let p = new Promise((res, err) => {
      if (freeze) clearTimeout(timer); //remove  prev timer
      timer = setTimeout(async () => {
        freeze = false;
        const r = await getChassisTerminationCustomers(strSearch); //request
        res(r);
      }, 1000);
    });

    p.then(function (x) {
      res(x);
    });
  });
};

const preSetOrderStatus = {
  "Pick and Run + Drop & Hook": "PULL_DELIVER_DROP_RETURN",
  "Pick and Run + Live Unload": "",
  "Prepull + Drop & Hook": "PULL_DROP_DELIVER_DROP_RETURN",
  "Prepull + Live Unload": "PULL_DROP_DELIVER_RETURN",
  
  // 'Pull Delivery Drop': 'PULL_DELIVER_DROP',
  // 'Pull Drop': 'PULL_DROP',
  
  "One Way Move": "PULL_RETURN",
  "Pick and Run + Gray Pool" : "PICK_RUN_GRAY_POOL",
  "Prepull + Gray Pool" : "PREPULL_GRAY_POOL"
 
};

const statusColors = [
  "#E5F1FF",
  "#F9EAFB",
  "#F2FCE9",
  "#FFF5E5",
  "#EBEEFA",
  "#FFE8E5",
  "#E5F1FF",
  "#F9EAFB",
  "#F2FCE9",
  "#FFF5E5",
];

class LoadDriverOrder extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      assignedDriver: null,
      selectedRoute: null,
      driverOrder: [],
      driverNote: "",
      officeNote: "",
      droppedIndex: null,
      CHASSISPICKCUSTOMER: props.selectedLoads.chassisPick
        ? this.props.selectedLoads.chassisPick
        : null,
      PULLCONTAINERCUSTOMER: props.selectedLoads.shipper[0]
        ? this.props.selectedLoads.shipper[0]
        : null,
        DELIVERLOADCUSTOMER: props.selectedLoads.consignee[0]
        ? this.props.selectedLoads.consignee[0]
        : null,
      RETURNCONTAINERCUSTOMER: props.selectedLoads.emptyOrigin
        ? this.props.selectedLoads.emptyOrigin
        : null,
      DROPCONTAINERCUSTOMER: null,
      CHASSISTERMINATIONCUSTOMER: props.selectedLoads.chassisTermination
      ? this.props.selectedLoads.chassisTermination
        : null,
      isPrePullCharge: props.selectedLoads.isPrePullCharge,
      isNextContainerNeedToPickup:
      props.selectedLoads.isNextContainerNeedToPickup,
      // addNoteModal: false,
      activeNoteTab: "load",
      allowDriverCompletion: props.selectedLoads.allowDriverCompletion,
      changeCompletionDate: null,
      groupTerminalData: [],
      showNote: false,
      selectedLoad: null,
      loading: false,
      isGrayPool: props.selectedLoads.isGrayPool,
      grayChassisNo: props.selectedLoads.grayChassisNo,
      grayContainerNo: props.selectedLoads.grayContainerNo,
      loadCompletedAt: props.selectedLoads.loadCompletedAt,
    };

    this.colorIndex = 0;
    // this.disabledDriver = false;
    this.submitNotes = this.submitNotes.bind(this);
    this.currentUserDetails = JSON.parse(getStorage("loggedInUser"));
    this.routeLayers = [];
    this.routeLayerGroup = null;
    this.userTimeFormat = isMilitaryTime();
  }

  showMap(props) {
    const oldReference_number = _.get(
      this.state.selectedLoad,
      "reference_number"
      );
      const newReference_number = _.get(props.selectedLoads, "reference_number");

    if (true && newReference_number != oldReference_number) {
      setTimeout(() => {
        this.loadMap();
      }, 1000);
      setTimeout(() => {
        this._getLoadRoute();
      }, 2000);
    }
    this.setState({ selectedLoad: props.selectedLoads });
  }

  _getLoadRoute() {
    if (this.map) {
      const { selectedLoads = {} } = this.props;
      const { reference_number } = selectedLoads;
      this.map && this.map.stop();
      if (reference_number) {
        this.setState({ isMapRouteLoading: true });
        getLoadRoute(reference_number)
          .then((routePath) => {
            //let routePoints = [];
            let pointsArr = routePath.map((d) => polyline.decode(d));
            //routePoints = pointsArr.slice().flat()
            routePoints = pointsArr
              .slice()
              .map((pArr) => pArr.map((p) => p.slice().reverse()));
            //geojson.data.geometry.coordinates = routePoints[2];
            this.updateRouteLine();
          })
          .catch(() => {
            this.setState({ isMapRouteLoading: false });
          });
      }
    }
  }

  componentDidMount() {
    this.getLoadDriverOrder();
    if (this.props.selectedLoads.officeNote) {
      this.setState({ officeNote: this.props.selectedLoads.officeNote });
    }
    if (this.props.selectedLoads.driverNote) {
      this.setState({ driverNote: this.props.selectedLoads.driverNote });
    }
    if (this.props.selectedLoads.terminal) {
      let carrierId = this.currentUserDetails._id;

      if (this.currentUserDetails.role == "carrier") {
        carrierId = this.currentUserDetails._id;
      } else if (this.currentUserDetails.role == "fleetmanager") {
        carrierId = this.currentUserDetails.fleetManager.carrier;
      }
      if (carrierId) {
        getCarrierByUserId(carrierId).then((response) => {
          let details = response.data.data;
          if (
            details &&
            details.carrier &&
            details.carrier.terminalDefaultDrop &&
            details.carrier.terminalDefaultDrop.length > 0
          ) {
            const terminalDefaultDrop =
              details.carrier.terminalDefaultDrop.find(
                (tdd) => tdd.terminal === this.props.selectedLoads.terminal._id
              );
            if (terminalDefaultDrop) {
              this.setState({
                DROPCONTAINERCUSTOMER: terminalDefaultDrop.customerId,
              });
            }
          }
        });
      }
    } else {
      if (
        this.props.selectedLoads.carrier.carrier &&
        this.props.selectedLoads.carrier.carrier.defaultAddress
      ) {
        getDefaultAddress({
          _id: this.props.selectedLoads.carrier.carrier.defaultAddress,
        }).then((dropcontainerCustomer) => {
          this.setState({ DROPCONTAINERCUSTOMER: dropcontainerCustomer });
        });
      }
    }
    this.showMap(this.props);
    if (this.props.handleSubmitLoad) {
      this.props.handleSubmitLoad(() => this.handleOrderStatusChange("update"));
    }

    const loggedInUser = JSON.parse(getStorage("loggedInUser"));
    const carrierUser = JSON.parse(getStorage("carrierDetail"));
    if(loggedInUser.role === "fleetmanager" && carrierUser.driverPreferences) {
      this.setState({ driverPreferences: true });
    }
    if (loggedInUser && loggedInUser.driverPreferences) {
      this.setState({ driverPreferences: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.selectedLoads.driverOrder, this.props.selectedLoads.driverOrder)) {
      this.setState({ driverOrder: this.props.selectedLoads.driverOrder });
    }
    if (!_.isEqual(prevProps.selectedLoads.grayContainerNo, this.props.selectedLoads.grayContainerNo)) {
      this.setState({ grayContainerNo: this.props.selectedLoads.grayContainerNo });
    }
    if (!_.isEqual(prevProps.selectedLoads.grayChassisNo, this.props.selectedLoads.grayChassisNo)) {
      this.setState({ grayChassisNo: this.props.selectedLoads.grayChassisNo });
    }
    if (!_.isEqual(prevProps.selectedLoads.loadCompletedAt, this.props.selectedLoads.loadCompletedAt)) {
      this.setState({ loadCompletedAt: this.props.selectedLoads.loadCompletedAt });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(this.props.selectedLoads, nextProps.selectedLoads) || !_.isEqual(this.state, nextState);
  }

  componentWillReceiveProps(props) {
    this.showMap(props);
    const loggedInUser = JSON.parse(getStorage("loggedInUser"));
    const carrierUser = JSON.parse(getStorage("carrierDetail"));
    if(loggedInUser.role === "fleetmanager" && carrierUser.driverPreferences) {
      this.setState({ driverPreferences: true });
    }
    if (loggedInUser && loggedInUser.driverPreferences) {
      this.setState({ driverPreferences: true });
    }
  }

  updateRouteLine() {
    if (this.map) {
      this.addRouteToMap();
    }
  }

  boundToRouteLine() {
    let coordinates = routePoints[0];
    if (coordinates.length > 0) {
      this.map.fitBounds(new window.L.LatLngBounds(coordinates[0], coordinates[coordinates.length - 1]));
    }
  }

  addRouteToMap() {
    if(!this.routeLayerGroup) {
      const layerGroup = new window.L.LayerGroup(null, {
        pane: "overlayPane",
      });
      layerGroup.addTo(this.map);
      this.routeLayerGroup = layerGroup;
    }
    if(this.routeLayers.length > 0 && this.routeLayerGroup) {
      // delete existing routes
      this.routeLayerGroup.clearLayers();
      this.routeLayers = [];
    }

    const routeLayer = window.L.polyline(routePoints[0].map((e) => e.reverse()), {
      color: "var(--color-primary-500)",
      weight: 7,
      opacity: 1.0,
    })

    this.routeLayers.push(routeLayer);
    routeLayer.addTo(this.routeLayerGroup);
    this.boundToRouteLine();
  }

  loadMap() {
    // if (this.mapContainer) {
    //   if (!this.map) {
    //     this.map = new mapboxgl.Map({
    //       container: this.mapContainer,
    //       style: "mapbox://styles/mapbox/streets-v9",
    //       center: [-75.25, 35.71],
    //       zoom: 1,
    //     });
    //   }
    // }
    if (this.mapContainer) {
      if (!this.map) {
        this.map = new window.L.Map("CustomerServiceSidebarMap", {
          zoom: 1,
          minZoom: 1,
          center: [35.71, -75.25],
          layers: [streetTile()],
        }); 
      }
    }
  }

  getLoadDriverOrder = () => {
    if (this.props.selectedLoads) {
      this.setState({
        driverOrder: this.props.selectedLoads.driverOrder,
        isPrePullCharge: this.props.selectedLoads.isPrePullCharge,
        isNextContainerNeedToPickup:
          this.props.selectedLoads.isNextContainerNeedToPickup,
        allowDriverCompletion: this.props.selectedLoads.allowDriverCompletion,
        changeCompletionDate: null,
        isGrayPool: this.props.selectedLoads.isGrayPool,
        grayChassisNo: this.props.selectedLoads.grayChassisNo,
        grayContainerNo: this.props.selectedLoads.grayContainerNo,
      });
    }
    if (this.props.selectedLoads.preSetOrderStatus) {
      this.setState({
        selectedRoute: this.props.selectedLoads.preSetOrderStatus,
      });
    } else {
      this.setState({ selectedRoute: "" });
    }
  };

  createLoadStatus(type, customerId, driver, prevType, loadAssignedDate, isGrayPool = false) {
    const status = {
      type: type,
      isVoidOut: false,
    };
    if (customerId) status.customerId = customerId;
    if (driver) status.driver = driver;
    if (prevType) status.prevType = prevType;
    if (loadAssignedDate) status.loadAssignedDate = loadAssignedDate;
    status.isGrayPool = isGrayPool
    return status;
  }

  onSelectedRouteChange(selectedRoute, reset) {
    this.setState({ selectedRoute });
    
    let driverOrder = [],isGrayPool = false;
    if (!reset)
      driverOrder = this.state.driverOrder.filter(
        (status) => status.isVoidOut || status.arrived || status.departed
      );

    const loadAssignedDate = driverOrder[driverOrder.length - 1]
      ? driverOrder[driverOrder.length - 1].loadAssignedDate
      : this.state.driverOrder[0] && this.state.driverOrder[0].loadAssignedDate;
    const customer = {
      DROPCONTAINER: this.state.DROPCONTAINERCUSTOMER,
      HOOKCONTAINER: this.state.DROPCONTAINERCUSTOMER,
      DELIVERLOAD: this.state.DELIVERLOADCUSTOMER,
      RETURNCONTAINER: this.state.RETURNCONTAINERCUSTOMER,
    };

    if (
      this.props.selectedLoads &&
      this.props.selectedLoads.type_of_load === "ROAD"
    ) {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus(
            "DELIVERLOAD",
            con,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DELIVERLOAD"],
          this.props.selectedLoads.driver,
          "DELIVERLOAD",
          loadAssignedDate
        )
      );
    } else if (selectedRoute === "PULL_DROP_DELIVER_DROP_RETURN") {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DROPCONTAINER"],
          this.props.selectedLoads.driver,
          "PULLCONTAINER",
          loadAssignedDate
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["HOOKCONTAINER"],
          null,
          "PULLCONTAINER",
          null
        )
      );
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus("DELIVERLOAD", con, null, null, null)
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          null,
          null,
          null
        )
      );
    } else if (selectedRoute === "PULL_DROP_DELIVER_RETURN") {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DROPCONTAINER"],
          this.props.selectedLoads.driver,
          "PULLCONTAINER",
          loadAssignedDate
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["HOOKCONTAINER"],
          null,
          "PULLCONTAINER",
          null
        )
      );
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus("DELIVERLOAD", con, null, null, null)
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          null,
          null,
          null
        )
      );
    } else if (selectedRoute === "PULL_DELIVER_DROP_RETURN") {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus(
            "DELIVERLOAD",
            con,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DELIVERLOAD"],
          this.props.selectedLoads.driver,
          "DELIVERLOAD",
          loadAssignedDate
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          null,
          null,
          null
        )
      );
    } else if (selectedRoute === "PICK_RUN_GRAY_POOL") {
      isGrayPool = true;
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate,
          )
        );
      });
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus(
            "DELIVERLOAD",
            con,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate,
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DELIVERLOAD"],
          this.props.selectedLoads.driver,
          "DELIVERLOAD",
          loadAssignedDate,
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null,
          true
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          null,
          null,
          null,
          true
        )
      );
    } else if (selectedRoute === "PREPULL_GRAY_POOL") {
      isGrayPool = true;
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate,
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DROPCONTAINER"],
          this.props.selectedLoads.driver,
          "PULLCONTAINER",
          loadAssignedDate,
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["HOOKCONTAINER"],
          null,
          "PULLCONTAINER",
          null,
        )
      );
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus("DELIVERLOAD", con, null, null, null)
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "DROPCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null,
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "HOOKCONTAINER",
          customer["DELIVERLOAD"],
          null,
          "DELIVERLOAD",
          null,
          true
        )
      );
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          null,
          null,
          null,
          true
        )
      );
    } else if (selectedRoute === "PULL_RETURN") {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          this.props.selectedLoads.driver,
          null,
          loadAssignedDate
        )
      );
    } else {
      this.props.selectedLoads.shipper.map((sh) => {
        driverOrder.push(
          this.createLoadStatus(
            "PULLCONTAINER",
            sh,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      this.props.selectedLoads.consignee.map((con) => {
        driverOrder.push(
          this.createLoadStatus(
            "DELIVERLOAD",
            con,
            this.props.selectedLoads.driver,
            null,
            loadAssignedDate
          )
        );
      });
      driverOrder.push(
        this.createLoadStatus(
          "RETURNCONTAINER",
          customer["RETURNCONTAINER"],
          this.props.selectedLoads.driver,
          null,
          loadAssignedDate
        )
      );
    }
    this.setState({ driverOrder, isGrayPool }, ()=>{
      this.handleOrderStatusChange("update");
    });
  }

  handleDragStart = (e) => {
    e.dataTransfer.setData("loadStatusType", e.target.id);
    e.stopPropagation();
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  handleKeyDown(event) {
    if(event.keyCode === 13) { 
      this.handleDragOver(event)
    }
  }
  handleDragEnter = (index) => {
    if (this.state.droppedIndex !== index)
      this.setState({ droppedIndex: index });
  };

  handleOnDrop = async (e) => {
    const loadStatusType = e.dataTransfer.getData("loadStatusType");
    let currentIndex = this.state.droppedIndex;
    let removeDriverIndex = null;

    // if (loadStatusType !== 'COMPLETED' && !this.state[`${loadStatusType}CUSTOMER`]) {
    //     toastr.show('You must select a customer first.', 'error');
    //     return;
    // }

    let driverOrder = _.cloneDeep(this.state.driverOrder);

    if (currentIndex === 100) {
      currentIndex = 0;
      if (
        (driverOrder[currentIndex] &&
          (driverOrder[currentIndex].isVoidOut ||
            driverOrder[currentIndex].arrived)) ||
        (loadStatusType === "CHASSISPICK" &&
          driverOrder[currentIndex].type !== "PULLCONTAINER") ||
        ["CHASSISPICK", "PULLCONTAINER"].indexOf(loadStatusType) === -1
      ) {
        return;
      }
      const loadAssignedDate =
        driverOrder[currentIndex] && driverOrder[currentIndex].loadAssignedDate;
      driverOrder.splice(
        currentIndex,
        0,
        this.createLoadStatus(
          loadStatusType,
          this.state[`${loadStatusType}CUSTOMER`],
          driverOrder[0].driver,
          null,
          loadAssignedDate
        )
      );
      this.setState({ driverOrder });
    } else {
      if (
        (driverOrder[currentIndex + 1] &&
          (driverOrder[currentIndex + 1].isVoidOut ||
            driverOrder[currentIndex + 1].arrived)) ||
        loadStatusType === "CHASSISPICK" ||
        (loadStatusType === "CHASSISTERMINATION" &&
          driverOrder[currentIndex].type !== "RETURNCONTAINER") ||
        (loadStatusType === "COMPLETED" &&
          currentIndex !== driverOrder.length - 1)
      ) {
        return;
      }

      if (loadStatusType === "COMPLETED") {
        this.setState({ allowDriverCompletion: true });
        return;
      }

      const loadAssignedDate = driverOrder[currentIndex + 1]
        ? driverOrder[currentIndex + 1].loadAssignedDate
        : driverOrder[currentIndex] &&
          driverOrder[currentIndex].loadAssignedDate;
      if (driverOrder[currentIndex].type === "DROPCONTAINER") {
        if (driverOrder.length === currentIndex + 1) {
          driverOrder.splice(
            currentIndex + 1,
            0,
            this.createLoadStatus(
              "HOOKCONTAINER",
              driverOrder[currentIndex].customerId,
              driverOrder[currentIndex].driver,
              driverOrder[currentIndex].prevType,
              loadAssignedDate,
              driverOrder[currentIndex].isGrayPool,
            )
          );
          removeDriverIndex = 0;
        }
        currentIndex += 1;
      }

      if (loadStatusType === "DROPCONTAINER") {
        let prevType = null;
        for (let i = currentIndex; i >= 0; i--) {
          if (
            driverOrder[i].type !== "DROPCONTAINER" &&
            driverOrder[i].type !== "HOOKCONTAINER" &&
            !driverOrder[i].isVoidOut
            ) {
            prevType = driverOrder[i].type;
            break;
          }
        }
        if (currentIndex + 1 !== driverOrder.length) {
          driverOrder.splice(
            currentIndex + 1,
            0,
            this.createLoadStatus(
              "HOOKCONTAINER",
              this.state[`${loadStatusType}CUSTOMER`],
              driverOrder[currentIndex].driver,
              prevType,
              loadAssignedDate,
              driverOrder[currentIndex].isGrayPool,
            )
          );
        }
        driverOrder.splice(
          currentIndex + 1,
          0,
          this.createLoadStatus(
            loadStatusType,
            this.state[`${loadStatusType}CUSTOMER`],
            driverOrder[currentIndex].driver,
            prevType,
            loadAssignedDate,
            driverOrder[currentIndex].isGrayPool,
          )
        );
        if (removeDriverIndex === null) removeDriverIndex = 2;
      } else {
        driverOrder.splice(
          currentIndex + 1,
          0,
          this.createLoadStatus(
            loadStatusType,
            this.state[`${loadStatusType}CUSTOMER`],
            driverOrder[currentIndex].driver,
            null,
            loadAssignedDate,
            driverOrder[currentIndex].isGrayPool,
          )
        );
      }

      this.setState({ driverOrder }, () => {
        if (removeDriverIndex !== null) {
          this.assignDriver(null, currentIndex + removeDriverIndex);
        }
        this.handleOrderStatusChange("update"); 
      });
    }       
  };

  assignDriver = (value, index) => {
    if(value && value.allInfos && value.allInfos.driver && value.allInfos.driver.accountHold){
      toastr.show('This driver is not able to be selected because they are marked in an ON HOLD status in Driver Profiles', 'error');
      return;
    }
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    // let driverOrder = _.clone(this.state.driverOrder);
    let startIndexOfLag;

    if (index < driverOrder.length) {
      for (let i = index; i >= 0; i--) {
        startIndexOfLag = i;
        if (driverOrder[i].type === "HOOKCONTAINER") break;
      }

      if (value) {
        for (let i = startIndexOfLag; i < driverOrder.length; i++) {
          if (!driverOrder[i].isVoidOut) {
            driverOrder[i].driver = value && value.allInfos;
            driverOrder[i].loadAssignedDate = moment()
              .tz(getStorage("timeZone"))
              .toISOString();
            if (driverOrder[i].type === "DROPCONTAINER") break;
          }
        }
      } else {
        for (let i = startIndexOfLag; i < driverOrder.length; i++) {
          if (!driverOrder[i].isVoidOut) {
            driverOrder[i].driver = null;
            delete driverOrder[i].arrived;
            delete driverOrder[i].departed;
            delete driverOrder[i].loadAssignedDate;
          }
        }
      }      
      this.setState({ driverOrder }, ()=>this.handleOrderStatusChange("update") );
    }
  };

  assignDriverOnRemoval = (value, loadAssignedDate, index) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    for (let i = index; i < driverOrder.length; i++) {
      if (!driverOrder[i].isVoidOut) {
        driverOrder[i].driver = value;
        driverOrder[i].loadAssignedDate = loadAssignedDate;
        if (driverOrder[i].type === "DROPCONTAINER") break;
      }
    }
    this.setState({ driverOrder });
  };

  removeStatus = (id) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    let driver, loadAssignedDate;
    if (driverOrder[id].type === "DROPCONTAINER") {
      if (
        driverOrder.length !== id + 1 &&
        driverOrder[id + 1].type === "HOOKCONTAINER"
      )
        driverOrder.splice(id + 1, 1);
      driverOrder.splice(id, 1);
      driver = driverOrder[id - 1].driver;
      loadAssignedDate = driverOrder[id - 1].loadAssignedDate;
    } else if (driverOrder[id].type === "HOOKCONTAINER") {
      if (id + 1 === driverOrder.length || id + 2 === driverOrder.length) {
        driverOrder.splice(id, 2);
      } else {
        driverOrder.splice(id - 1, 2);
        driver = driverOrder[id - 2].driver;
        loadAssignedDate = driverOrder[id - 2].loadAssignedDate;
      }
    } else {
      driverOrder.splice(id, 1);
    }
    this.setState({ driverOrder }, () => {
      if (driver) {
        this.assignDriverOnRemoval(driver, loadAssignedDate, id);
      }
      this.handleOrderStatusChange("update")
    });
  };

  removeExtraLeg = (index) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    driverOrder.splice(index);
    
    this.setState({ driverOrder }, () => {
      const formDataOrder = new FormData();
      formDataOrder.append(
        "reference_number",
        this.props.selectedLoads && this.props.selectedLoads.reference_number
      );
      formDataOrder.append("driverOrder", JSON.stringify(driverOrder));
      formDataOrder.append("preSetOrderStatus", this.state.selectedRoute);
      formDataOrder.append(
        "allowDriverCompletion",
        this.state.allowDriverCompletion ? true : false
      );

      formDataOrder.append(
        "isPrePullCharge",
        this.state.isPrePullCharge ? true : false
      );
      formDataOrder.append(
        "isNextContainerNeedToPickup",
        this.state.isNextContainerNeedToPickup ? true : false
      );
      formDataOrder.append("isCompleteLoad",true)
      setLoadStatusOrder(formDataOrder)
      .then(()=>{
        browserHistory.push(`/tms/customer-service/load?reference_number=${this.props.selectedLoads.streetTurn}`);
      })
    });
  }
  validateOrderStatus = (driverOrder) => {
    // let isValid = driverOrder.filter((status) => !status.customerId).length > 0? false: true;
    // if(!isValid){
    //     toastr.show("Please assign a driver and/or a customer.", 'error');
    //     return false;
    // }
    let inValidStatus = driverOrder.find(
      (status) =>
        status.driver &&
        !status.customerId &&
        ["CHASSISPICK", "RETURNCONTAINER", "CHASSISTERMINATION"].indexOf(
          status.type
        ) === -1
    );
    if (inValidStatus) {
      toastr.show("A valid customer is required here." + inValidStatus.type, "error");
      return false;
    }

    inValidStatus = driverOrder.find(
      (status) => status.driver && !status.loadAssignedDate
    );
    if (inValidStatus) {
      toastr.show(
        "Load Assigned Date is required for " + inValidStatus.type,
        "error"
      );
      return false;
    }

    if (
      this.props.selectedLoads &&
      this.props.selectedLoads.preSetOrderStatus === this.state.selectedRoute
    ) {
      if (driverOrder[0] && driverOrder[0].driver) {
        for (let i = 1; i < driverOrder.length; i++) {
          if(driverOrder[0].driver && !driverOrder[0].isVoidOut){
            if (!driverOrder[i].driver) inValidStatus = true;
            if (driverOrder[i].type === "DROPCONTAINER") break;
          }
        }
        if (inValidStatus) {
          toastr.show("A driver is required.", "error");
          return false;
        }
      }
    }

    const fDriverIndx = driverOrder.findIndex((status) => !status.driver && !status.isVoidOut);
    if (fDriverIndx > -1) {
      driverOrder.forEach((status, i) => {
        if (i > fDriverIndx) {
          if (!status.isVoidOut && status.driver) {
            inValidStatus = true;
          }
        }
      });
      if (inValidStatus) {
        toastr.show("Driver is required", "error");
        return false;
      }
    }

    if (
      this.props.selectedLoads &&
      this.props.selectedLoads.type_of_load != "ROAD"
    ) {
      if (
        ["DROPCONTAINER", "RETURNCONTAINER", "CHASSISTERMINATION"].indexOf(
          driverOrder[driverOrder.length - 1].type
        ) === -1
      ) {
        toastr.show(
          "Last status must be either dropped, return container or chassis termination",
          "error"
        );
        return false;
      }
    }
    return true;
  };

  changeCompletionStatus = (type, index, date, statusId) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    driverOrder[index][type] = moment(date).toISOString();

    const changeCompletionDate = {
      statusId: statusId,
      type: type,
      date: date,
    };
    this.setState({ driverOrder, changeCompletionDate });
  };

  changeLoadAssignedDate = (index, date) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);

    const loadAssignedDate = date && moment(date).toISOString();
    let startIndexOfLag;

    for (let i = index; i >= 0; i--) {
      startIndexOfLag = i;
      if (driverOrder[i].type === "HOOKCONTAINER") break;
    }

    for (let i = startIndexOfLag; i < driverOrder.length; i++) {
      if (loadAssignedDate) {
        driverOrder[i].loadAssignedDate = loadAssignedDate;
      } else {
        delete driverOrder[i].loadAssignedDate;
      }
      if (driverOrder[i].type === "DROPCONTAINER") break;
    }

    this.setState({ driverOrder });
  };

  changeLoadCompletedDate = () => {
    if(this.state.loadCompletedAt){
      const formData = new FormData();
      formData.append(
        "reference_number",
        this.props.selectedLoads &&
          this.props.selectedLoads.reference_number
      );
      formData.append(
        "loadCompletedAt",
        this.state.loadCompletedAt
      );

      updateLoadCompletedDate(formData)
        .then((result) => {
          toastr.show("You have updated load completed date successfully.", "success");
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          toastr.show("The update has failed.  Please try again.", "error");
          console.log("Error ------", err);
        });
    }else{
      toastr.show("Enter Completed Date", "error");
      return;
    }
  }

  updateDriverOrderById = (type, driverOrderId) => {
    this.setState({ isLoading: true });

    const formData = new FormData();
    formData.append(
      "reference_number",
      this.props.selectedLoads && this.props.selectedLoads.reference_number
    );
    formData.append("driverOrderId", driverOrderId._id);
    formData.append("arrivedOrDeparted", type);
    if (this.state.changeCompletionDate) {
      formData.append(
        "date",
        moment(this.state.changeCompletionDate.date).toISOString()
      );
      formData.append("strictChange", true);
    }
    updateDriverOrderById(formData)
      .then((result) => {
        toastr.show("You have updated the status!", "success");
        if(type === "departed" && (driverOrderId.type === 'PULLCONTAINER' || driverOrderId.type === 'HOOKCONTAINER') && driverOrderId.isBobtail){
          const newFormData = new FormData();
          newFormData.append("description", "Bobtail");
          newFormData.append("amount", 0);
          newFormData.append("approved", false);
          newFormData.append("driverId", driverOrderId.driver && driverOrderId.driver._id);
          newFormData.append("reference_number", this.props.selectedLoads && this.props.selectedLoads.reference_number);
          newFormData.append("loadType", driverOrderId.type);
          if(this.props?.selectedLoads?.terminal){
            newFormData.append("terminal", this.props.selectedLoads.terminal._id);
          }
          manualDriverPay(newFormData)
          this.manualCustomerRate()
        }
        this.setState({ changeCompletionDate: null, isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toastr.show("The update has failed.  Please try again.", "error");
        console.log("Error ------", err);
      });
  };

  manualCustomerRate = () => {
    let pricing = (this.props.selectedLoads && this.props.selectedLoads.pricing) ? this.props.selectedLoads.pricing : [];
    let existingBobtailCharge = pricing.find((price) => price.name === 'bobtail_charge');
    if(!existingBobtailCharge){
      let bobtailPrice = {
        "amount": 0,
        "chargePerDay": 0,
        "chargePerMinute": 0,
        "finalAmount": "0.00",
        "unit": "0.00",
        "freeDays": 0,
        "perType": "fixed",
        "name": "bobtail_charge",
        "chargeType": "MANUALLY_CHANGED",
        "description": "Bobtail"
      }
      pricing.push({ ...bobtailPrice })
      var pricingData = {
        pricing: pricing,
        reference_number : this.props.selectedLoads.reference_number,
        isSaveCustomerRates: false,
      };
      UpdatePricing("tms/updatePricingLoad", pricingData)
    }
  }
  removeStatusDriverOrderById = (type, driverOrderId) => {

    this.setState({ isLoading: true });
    const formData = new FormData();
    formData.append(
      "reference_number",
      this.props.selectedLoads &&
        this.props.selectedLoads.reference_number
    );
    formData.append("driverOrderId", driverOrderId);
    formData.append("arrivedOrDeparted", type);

    removeStatusDriverOrderById(formData)
      .then((result) => {
        toastr.show("You have updated the status!", "success");
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toastr.show("The update has failed.  Please try again.", "error");
        console.log("Error ------", err);
      });


    // confirm(
    //   "Alert",
    //   `Do you really want to remove this status date?`,
    //   (confirm) => {
    //     if (confirm) {
    //    ß
    //     }
    //   }
    // );
  };

  pullVoid = (status, index) => {
    if (!status.driver) {
      toastr.show("Please assign a driver.", "error");
      return;
    }

    let driverOrder = _.cloneDeep(this.state.driverOrder);
    let isRemoveDriver = false
    if(status.type === 'PULLCONTAINER' || status.type === 'HOOKCONTAINER'){
      isRemoveDriver = true
    }
    const newStatus = { ...driverOrder[index] };
    delete newStatus.arrived;
    delete newStatus.departed;

    driverOrder.splice(index + 1, 0, newStatus);
    driverOrder[index].isVoidOut = true;
    this.setState({ driverOrder }, () => {
      this.updateStatus(true,isRemoveDriver,true,false,status);
    });
  };

  removePullVoid = (status, index) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    driverOrder[index].isVoidOut = false;
    let driverId = driverOrder[index].driver
    if (driverOrder[index + 1] && driverOrder[index + 1].type === status.type) {
      driverOrder.splice(index + 1, 1);
    }
    for (let i = index; i < driverOrder.length; i++) {
      if (!driverOrder[i].isVoidOut) {
        driverOrder[i].driver = driverId;
        if (driverOrder[i].type === "DROPCONTAINER") break;
      }
    }

    this.setState({ driverOrder }, () => {
      this.updateStatus(true);
    });
  };

  updateStatus = (keepModalOpen,isRemoveDriver,isVoidOut,isBobtail,currentLeg) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    if (!this.validateOrderStatus(driverOrder)) {
      return;
    }
    let customerAddress = currentLeg && `${ currentLeg.address ? currentLeg.address.address ? currentLeg.address.address : "" : ""}`.trim()
    this.props.changeSavingLoadStatus &&
      this.props.changeSavingLoadStatus(true);
    driverOrder.forEach((status) => {
      if (status.customerId) {
        status.address = status.customerId.address;
        status.city = status.customerId.city;
        status.state = status.customerId.state;
        status.country = status.customerId.country;
        status.zip_code = status.customerId.zip_code;
        status.company_name =
          status.customerId.company_name &&
          status.customerId.company_name.toUpperCase();
        status.customerId = status.customerId._id;
      } else {
        delete status.address;
        delete status.city;
        delete status.state;
        delete status.country;
        delete status.zip_code;
        delete status.company_name;
        delete status.customerId;
      }

      if (status.driver) {
        status.driverName = `${status.driver.name} ${status.driver.lastName || ""}`
        status.driver = status.driver._id;
      } else {
        delete status.driver;
        delete status.driverName;
      }
    });

    const formData = new FormData();
    formData.append(
      "reference_number",
      this.props.selectedLoads && this.props.selectedLoads.reference_number
    );
    formData.append("driverOrder", JSON.stringify(driverOrder));
    formData.append("preSetOrderStatus", this.state.selectedRoute);
    formData.append(
      "allowDriverCompletion",
      this.state.allowDriverCompletion ? true : false
    );

    formData.append(
      "isPrePullCharge",
      this.state.isPrePullCharge ? true : false
    );
    formData.append(
      "isNextContainerNeedToPickup",
      this.state.isNextContainerNeedToPickup ? true : false
    );
    formData.append("isGrayPool",this.state.isGrayPool ? true : false);
    if(this.state.isGrayPool){
      if(this.state.grayContainerNo) formData.append("grayContainerNo",this.state.grayContainerNo)
      if(this.state.grayChassisNo) formData.append("grayChassisNo",this.state.grayChassisNo)
      if(this.state.grayChassisType) formData.append("grayChassisType",this.state.grayChassisType)
      if(this.state.grayChassisSize) formData.append("grayChassisSize",this.state.grayChassisSize)
      if(this.state.grayChassisOwner) formData.append("grayChassisOwner",this.state.grayChassisOwner)
      if(this.state.grayChassisId) formData.append("grayChassisId",this.state.grayChassisId)
    }
    setLoadStatusOrder(formData)
      .then((result) => {
        if(isVoidOut){
          const newFormData = new FormData();
            newFormData.append("description", "Void Out");
            newFormData.append("amount", 0);
            newFormData.append("approved", false);
            newFormData.append("driverId", currentLeg.driver && currentLeg.driver._id);
            newFormData.append("reference_number", this.props.selectedLoads && this.props.selectedLoads.reference_number);
            if(customerAddress){
              newFormData.append("to", customerAddress);
            }
            newFormData.append("loadType", currentLeg.type);
            if(this.props?.selectedLoads?.terminal){
              newFormData.append("terminal", this.props.selectedLoads.terminal._id);
            }
            manualDriverPay(newFormData)
        }
        if(isRemoveDriver) {
          const formData1 = new FormData();
          formData1.append(
            "reference_number",
            this.props.selectedLoads &&
              this.props.selectedLoads.reference_number
          );
          this.props.actions.hardRemoveDriver(formData1)
        }
        if(isBobtail){
            const newFormData = new FormData();
            newFormData.append("description", "Bobtail");
            newFormData.append("amount", 0);
            newFormData.append("approved", false);
            newFormData.append("driverId",  currentLeg.driver && currentLeg.driver._id);
            newFormData.append("reference_number", this.props.selectedLoads && this.props.selectedLoads.reference_number);
            newFormData.append("loadType", currentLeg.type);
            if(this.props?.selectedLoads?.terminal){
              newFormData.append("terminal", this.props.selectedLoads.terminal._id);
            }
            manualDriverPay(newFormData)
            this.manualCustomerRate()
        }
        toastr.show("Updated Successfully", "success");
        this.props.changeSavingLoadStatus &&
          this.props.changeSavingLoadStatus(false);
        if (this.props.closeStatusModal && !keepModalOpen) {
          // this.props.closeStatusModal();
        }
      })
      .catch((err) => {
        this.props.changeSavingLoadStatus &&
          this.props.changeSavingLoadStatus(false);
        toastr.show("The update has failed.  Please try again.", "error");
        console.log("Error ------", err);
      });
  };

  completeLoad = () => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    if (!this.validateOrderStatus(driverOrder)) {
      return;
    }

    const inValid = driverOrder.find((status) => !status.driver);
    if (inValid) {
      toastr.show("A driver is required.", "error");
    } else {
      this.setState({ isLoading: true });
      const driverOrderId = driverOrder[driverOrder.length - 1]._id;
      const formData = new FormData();
      formData.append(
        "reference_number",
        this.props.selectedLoads &&
          this.props.selectedLoads.reference_number
      );
      formData.append("driverOrderId", driverOrderId);
      formData.append("arrivedOrDeparted", "departed");
      formData.append("completeLoad", true);

      updateDriverOrderById(formData)
        .then((result) => {
          toastr.show("Completed!", "success");
          this.setState({ isLoading: false });
          // if (this.props.closeStatusModal) {
          //   this.props.closeStatusModal();
          // }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          toastr.show("The update has failed.  Please try again.", "error");
          console.log("Error ------", err);
        });


      // confirm(
      //   "Alert",
      //   `Do you really want to complete this load?`,
      //   (confirm) => {
      //     if (confirm) {
            
      //     }
      //   }
      // );
    }
  };

  uncompleteLoad = () => {
    this.setState({ isLoading: true });
    const formData = new FormData();
    formData.append(
      "reference_number",
      this.props.selectedLoads &&
        this.props.selectedLoads.reference_number
    );

    uncompleteLoad(formData)
      .then((result) => {
        toastr.show("You have uncompleted this load.", "success");
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        toastr.show("The update has failed.  Please try again.", "error");
        console.log("Error ------", err);
      });


    // confirm(
    //   "Alert",
    //   `Do you really want to uncomplete this load?`,
    //   (confirm) => {
    //     if (confirm) {
          
    //     }
    //   }
    // );
  };
  removeStreetTurn = (reference_number,streetTurn)=>{
    const formData = new FormData();
    formData.append("reference_number", reference_number);
    formData.append("streetTurn",streetTurn)
    confirm(
      "Remove Street Turn?",
      `Are You sure to Remove Street Turn?`,
      (confirm) => {
        if (confirm) {
          this.props.actions.removeStreetTurn(formData).then(() => {
            toastr.show("Removed!", "success");
          });
        }
      }
    );
  }

  handleOrderStatusChange = (label) => {
    const disabled =
      _.isEqual(this.state.driverOrder, this.props.selectedLoads.driverOrder) &&
      this.props.selectedLoads.isPrePullCharge === this.state.isPrePullCharge &&
      this.props.selectedLoads.isNextContainerNeedToPickup ===
        this.state.isNextContainerNeedToPickup &&
      this.props.selectedLoads.allowDriverCompletion ===
        this.state.allowDriverCompletion &&
      this.props.selectedLoads.grayContainerNo ===
          this.state.grayContainerNo &&
      this.props.selectedLoads.grayChassisNo ===
          this.state.grayChassisNo;
    const isCompleted =
      [
        "COMPLETED",
        "BILLING",
        "APPROVED",
        "UNAPPROVED",
        "REBILLING",
        "PARTIALLY_PAID",
        "FULL_PAID",
      ].indexOf(this.props.selectedLoads.status) > -1;
    
    if (  
      this.state.grayContainerNo &&
      !/^[A-Za-z]{4}\d{6,8}$/.test(this.state.grayContainerNo)
    ) {
      toastr.show("Please Enter Correct Gray Container No", "warning");
      this.setState({ grayContainerNo: "" });
      this.props.changeSavingLoadStatus && this.props.changeSavingLoadStatus(false);
      return;
    }
    
    // if (!disabled && !isCompleted) {
    //   confirm(
    //     "Alert",
    //     `Do you really want to ${label} Routing?`,
    //     (confirm) => {
    //       if (confirm) {
    //         if (label === "update") {
    //           this.updateStatus();
    //         } else if (label === "discard") {
    //           this.getLoadDriverOrder();
    //         }
    //       }
    //     }
    //   );
    // }
    if(!disabled && !isCompleted){
      if(label === "update"){
        this.updateStatus();
      } 
      else if(label === "discard"){
        this.getLoadDriverOrder();
      }
    }
     else if (disabled) {
      toastr.show("There are no modified fields.", "error");
    } else if (isCompleted) {
      toastr.show("The load is now completed!", "error");
    }
  };

  setCustomerToStatus = (index, value, status) => {
    
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    driverOrder[index].customerId = value && value.allInfos;

    if (status.type === "DROPCONTAINER") {
      if (
        driverOrder[index + 1] &&
        driverOrder[index + 1].type === "HOOKCONTAINER"
      ) {
        driverOrder[index + 1].customerId = value && value.allInfos;
      }
    } else if (status.type === "HOOKCONTAINER") {
      driverOrder[index - 1].customerId = value && value.allInfos;
    }
    this.setState({ driverOrder }, ()=>this.handleOrderStatusChange("update"));        
    
  };

  submitNotes() {
    const tab = this.state.activeNoteTab;
    this.setState({
      loading: true,
      showNote: false,
    });
    let key = null;
    const data = {
      reference_number: this.props.selectedLoads.reference_number,
    };

    if (this.state.officeNote) {
      data.officeNote = this.state.officeNote;
      key = "officeNote";
      this.setState({
        loading: true,
      });
    }
    if (this.state.driverNote) {
      data.driverNote = this.state.driverNote;
      key = "driverNote";
      this.setState({
        loading: true,
      });
    }
    if (this.state.officeNote && this.state.driverNote) {
      this.setState({
        showNote: false
      })
    }
    if (tab && tab !== "" && data.reference_number && key) {
      saveLoadNotes(data)
        .then(() => {
          this.setState({
            loading: false,
          });
          toastr.show("Notes have been added.", "success");
          if (key && this.props.changeList) {
            this.props.changeList(this.state[`${key}`]);
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
          });
          toastr.show(err.message, "error");
        });
    }
  }

  createLegsFromDriverOrder = (driverOrder) => {
    const driverLegs = [],
      legIndexes = [0];
    let current = 0,
      lastPos = 0;
    while (current < driverOrder.length) {
      if (driverOrder[current].type === "DROPCONTAINER") {
        driverLegs.push(driverOrder.slice(lastPos, current + 1));
        lastPos = current + 1;
        legIndexes.push(lastPos);
      }
      current++;
    }
    driverLegs.push(driverOrder.slice(lastPos, current + 1));
    return { driverLegs, legIndexes };
  };

  assignBobtail = (value, index,status) => {
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    if (index < driverOrder.length) {
      for (let i = index; i >= 0; i--) {
        driverOrder[i].isBobtail = value; break;
      }
      this.setState({ driverOrder },()=>{
        let isBobtail = false;
        if(status.departed && (status.type === 'PULLCONTAINER' || status.type === 'HOOKCONTAINER') && value){
          isBobtail = true;
        }
        if(typeof value === 'boolean' && !value && status.driver && status.driver._id) {
          let params = {
            reference_number: this.props.selectedLoads && this.props.selectedLoads.reference_number,
            loadType: status.type,
            userId: status.driver._id
          }
          removeBobtailDriverPay(params)
        }
        this.updateStatus(true,false,false,isBobtail,status);
      });
    }
  };

  preSetOrderStatusUpdate = (value) => {
    this.setState({isGrayPool: value});
    let driverOrder = _.cloneDeep(this.state.driverOrder);
    if(!value){
      for (let i = 0; i < driverOrder.length; i++) {
        driverOrder[i].isGrayPool = false;
      }
    }else{
      let hookIndex = -1
      for (let i = 0; i < driverOrder.length; i++) {
        if (driverOrder[i].type != 'HOOKCONTAINER')
            continue;
        hookIndex = i;
      }
      for(let i = hookIndex; i< driverOrder.length; i++){
        driverOrder[i].isGrayPool = true;
      }
    }
    this.setState({driverOrder}, ()=>this.handleOrderStatusChange("update"))
  }

  getChassis = (searchTerm = "") => {
    return new Promise((resolve, reject) => {
      this.props
        .getTMSChassis({ limit: 10, searchTerm })
        .then((result) => {
          let data =
            result &&
            result.map((d) => ({
              value: d._id,
              label: d.chassisNo,
              allInfo: d,
            }));
          resolve(data);
        })
        .catch((err) => {
          console.log("-*-* GET Chassis error -*-*", err);
          reject(err);
        });
    });
  };

  onRemovePress(e, input, showToast = true) {
    const params = {
      reference_number: this.props.selectedLoads.reference_number,
      key: input.name,
    };
    if (!this.props.disabled) {
      removeValueLoad(params).then((result) => {
        showToast && toastr.show("Successfully removed", "success");
      });
    }
  }
  
  grayChassisUpdate(value) {
    if (value) {
      this.setState({
        grayChassisNo: value.label,
        grayChassisType: value.allInfos ? value.allInfos.chassisType ? value.allInfos.chassisType._id : null : null, 
        grayChassisSize: value.allInfos ? value.allInfos.chassisSize ? value.allInfos.chassisSize._id : null : null, 
        grayChassisOwner: value.allInfos ? value.allInfos.chassisOwner ? value.allInfos.chassisOwner._id : null : null, 
        grayChassisId: value.value ? value.value : null
      });
    }
  }

  getDrivers(info, dIndex) {
    let drivers = [];
    if (this.props.driverList) {
      let ddrivers = this.props.driverList;
      const deliverIndex = info.driverOrder.findIndex((d) => d.type === 'DELIVERLOAD');
      if(this.state.driverPreferences && (info.overWeight || info.hazmat || info.liquor) && dIndex < deliverIndex) {
        if (info.overWeight) {
          ddrivers.forEach((d) => {
            if(!d.driver.overweight && !_.intersection(d.driver.owerWeightStates, info.consignee.map((d) => d.state)).length > 0) {
              d.disableValue = true
            }
          });
        }
        if (info.hazmat) {
          ddrivers.forEach((d) => {
            if(!d.driver.hazmat) {
              d.disableValue = true
            }
          });
        }
        if (info.liquor) {
          ddrivers.forEach((d) => {
            if(d.driver.liquor !== "true") {
              d.disableValue = true
            }
          });
        }
        drivers = ddrivers;
      } else {
        ddrivers.forEach((d) => d.disableValue = false)
        drivers = ddrivers;
      }
    } else {
      drivers = [];
    }
    return drivers.map((d) => {
      return {
        value: d._id,
        label: `${d.name} ${d.lastName || ""}`.trim(),
        allInfos: d,
        isDisabled: d.disableValue,
        isDeleted: d.isDeleted,
        isBlocked: d.isBlocked
      };
    });
  }
  renderReturn() {
    const disabled =
      _.isEqual(this.state.driverOrder, this.props.selectedLoads.driverOrder) &&
      this.props.selectedLoads.isPrePullCharge === this.state.isPrePullCharge &&
      this.props.selectedLoads.isNextContainerNeedToPickup ===
        this.state.isNextContainerNeedToPickup &&
      this.props.selectedLoads.allowDriverCompletion ===
        this.state.allowDriverCompletion &&
      this.props.selectedLoads.grayChassisNo ===
      this.state.grayChassisNo && 
      this.props.selectedLoads.grayContainerNo ===
      this.state.grayContainerNo;

    const isCompleted =
      [
        "COMPLETED",
        "BILLING",
        "APPROVED",
        "UNAPPROVED",
        "REBILLING",
        "PARTIALLY_PAID",
        "FULL_PAID",
      ].indexOf(this.props.selectedLoads.status) > -1;
    const lastStatus =
      this.props.selectedLoads.driverOrder &&
      this.props.selectedLoads.driverOrder[
        this.props.selectedLoads.driverOrder.length - 1
      ];
    const loadCompletedAt = this.props.selectedLoads.loadCompletedAt;
    const completedStatus = this.state.driverOrder.find(
      (status) => status.arrived && !status.isVoidOut
    );
    const isHook = this.state.driverOrder.find((order) => order.type === 'HOOKCONTAINER')
    // this.disabledDriver = false;

    const PRESET_ORDER_STATUS = Object.keys(preSetOrderStatus).map((key) => {
      return {
        label: key,
        value: preSetOrderStatus[key],
      };
    });
    const selectedLoad = this.props.selectedLoads;
    const { driverLegs, legIndexes } = this.createLegsFromDriverOrder(
      this.state.driverOrder
    );

    return (
      <React.Fragment>
        <div className="tab">
          {this.props.dispatcherModal && (
            <div className="d-flex align-items-center m-2 mb-3">
              <h5 className="font-20 mb-0">
                Load #:{" "}
                {this.props.selectedLoads &&
                  this.props.selectedLoads.reference_number}
              </h5>
              <div className="d-flex ml-auto">
                <button
                  className="btn btn-white shadow-none mr-10"
                  onClick={() => this.props.closeStatusModal()}
                >
                  Close
                </button>
                {/* <button
                  className="btn btn-success mr-10"
                  onClick={() => this.handleOrderStatusChange("update")}
                  disabled={disabled || isCompleted}
                >
                  Update
                </button> */}
                {/* {!this.props.dispatcherModal && <button className="btn btn-danger mr-10" onClick={() => this.handleOrderStatusChange('discard')} disabled={disabled || isCompleted}>Discard</button> } */}
              </div>
            </div>
          )}
          <div className="form-row-md mt-3">
            {this.props.dispatcherModal && (
              <div className="col-md" style={{ maxWidth: 270 }}>
                <div className="card p-15 mb-1">
                  <h5>Customer</h5>
                  <div>
                    {selectedLoad.caller
                      ? selectedLoad.caller.company_name
                      : ""}
                  </div>
                  <div className="mb-10">
                    {selectedLoad.caller && selectedLoad.caller.address
                      ? selectedLoad.caller.address.address
                      : ""}
                  </div>
                  {selectedLoad.caller && selectedLoad.caller.mobile && (
                    <div className="mb-10">
                      <IconPhone className="mr-2" />
                      <span>{selectedLoad.caller.mobile}</span>
                    </div>
                  )}
                  {selectedLoad.caller && selectedLoad.caller.billingEmail && (
                    <div>
                      <IconAt className="mr-2" />
                      <span>{selectedLoad.caller.billingEmail}</span>
                    </div>
                  )}
                </div>

                <div className="card p-15 mb-1">
                  <h5>Summary</h5>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Created by </span>&nbsp;
                    <span>{`${selectedLoad.addedBy.name}`.trim()}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Container #</span>
                    <span>{selectedLoad.containerNo}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">BOL #</span>
                    <span>{selectedLoad.bolbkg}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Chassis #</span>
                    <span>{selectedLoad.chassisNo}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">SSL</span>
                    <span>
                      {selectedLoad.containerOwner
                        ? selectedLoad.containerOwner.company_name
                        : ""}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Size</span>
                    <span>
                      {selectedLoad.containerSize
                        ? selectedLoad.containerSize.name
                        : ""}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Type</span>
                    <span>
                      {selectedLoad.containerType
                        ? selectedLoad.containerType.name
                        : ""}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Reference</span>
                    <span>
                      {selectedLoad.secondaryReferenceNo
                        ? selectedLoad.secondaryReferenceNo
                        : ""}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-10">
                    <span className="text-muted">Total Miles</span>
                    <span>{selectedLoad.distance}</span>
                  </div>
                  <div className="no-block align-items-center">
                      <h4 className="card-title">Preview: </h4>
                      <div className="ml-auto">
                      <div
                        id="CustomerServiceSidebarMap"
                        className="mapboxgl-map-300"
                        style={{ height: 300 }}
                        ref={(el) => (this.mapContainer = el)}
                      ></div>
                      <div className="overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col" style={{ maxWidth: 250 }}>
              <div className="card p-10 mb-10">
                {!completedStatus && (
                  <React.Fragment>
                    <div className="form-group mb-0">
                      <label>Load Template</label>
                      <Select
                        name="loadRoute"
                        options={PRESET_ORDER_STATUS}
                        value={PRESET_ORDER_STATUS.find(
                          (val) => val.value === this.state.selectedRoute
                        )}
                        onChange={(value) =>
                          this.onSelectedRouteChange(value.value)
                        }
                        className="w-100"
                        styles={smallSelectStyle}
                      />
                    </div>
                    <div className="hr-light"></div>
                  </React.Fragment>
                )}
                <div className="form-group">
                  <label>Drag & Drop to Add Legs</label>
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.type_of_load !== "ROAD" && (
                      <button
                        className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                        id="CHASSISPICK"
                        draggable
                        onDragStart={this.handleDragStart}
                        onDragOver={this.handleDragOver}
                        onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                          this.handleOrderStatusChange("update")
                        })}
                      >
                        <IconDrag className="mr-10 text-gray-200" />
                        {ICONS["CHASSISPICK"]}
                        <span>Chassis Pick</span>
                      </button>
                    )}
                  <button
                    className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                    id="PULLCONTAINER"
                    draggable
                    onDragStart={this.handleDragStart}
                    onDragOver={this.handleDragOver}
                    onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                      this.handleOrderStatusChange("update")
                    })}
                  >
                    <IconDrag className="mr-10 text-gray-200" />
                    {ICONS["PULLCONTAINER"]}
                    Pull Container
                  </button>
                  <button
                    className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                    id="DELIVERLOAD"
                    draggable
                    onDragStart={this.handleDragStart}
                    onDragOver={this.handleDragOver}
                    onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                      this.handleOrderStatusChange("update")
                    })}
                  >
                    <IconDrag className="mr-10 text-gray-200" />
                    {ICONS["DELIVERLOAD"]}
                    Deliver Load
                  </button>
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.type_of_load !== "ROAD" && (
                      <button
                        className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                        id="RETURNCONTAINER"
                        draggable
                        onDragStart={this.handleDragStart}
                        onDragOver={this.handleDragOver}
                        onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                          this.handleOrderStatusChange("update")
                        })}
                      >
                        <IconDrag className="mr-10 text-gray-200" />
                        {ICONS["RETURNCONTAINER"]}
                        Return Container
                      </button>
                    )}
                  <button
                    className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                    id="DROPCONTAINER"
                    draggable
                    onDragStart={this.handleDragStart}
                    onDragOver={this.handleDragOver}
                    onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                      this.handleOrderStatusChange("update")
                    })}
                  >
                    <IconDrag className="mr-10 text-gray-200" />
                    {ICONS["DROPCONTAINER"]}
                    Drop Container
                  </button>
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.type_of_load !== "ROAD" && (
                      <button
                        className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                        id="CHASSISTERMINATION"
                        draggable
                        onDragStart={this.handleDragStart}
                        onDragOver={this.handleDragOver}
                        onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                          this.handleOrderStatusChange("update")
                        })}
                      >
                        <IconDrag className="mr-10 text-gray-200" />
                        {ICONS["CHASSISTERMINATION"]}
                        Chassis Termination
                      </button>
                    )}
                  <button
                    className="btn btn-outline-light btn-lg mb-1 d-flex align-items-center justify-content-start w-100 px-2 grabbable"
                    id="COMPLETED"
                    draggable
                    onDragStart={this.handleDragStart}
                    onDragOver={this.handleDragOver}
                    onDragEnd={() => this.setState({ droppedIndex: null }, ()=>{
                      this.handleOrderStatusChange("update")
                    })}
                  >
                    <IconDrag className="mr-10 text-gray-200" />
                    {ICONS["COMPLETED"]}
                    Completed
                  </button>
                </div>
              </div>  
              <div className="card">
                <div className="pt-10 px-10">
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.type_of_load === "IMPORT" && this.props.selectedLoads.driverOrderId && this.props.selectedLoads.containerOwner && this.props.selectedLoads.containerNo &&  (
                      // this.props.selectedLoads.type_of_load === "IMPORT" && !(['COMPLETED', 'APPROVED', 'BILLING', 'UNAPPROVED', 'REBILLING', 'PARTIAL_PAID', 'FULL_PAID',]).includes(this.props.selectedLoads.status) && (
                      <React.Fragment>
                        <label>Export Load</label>
                        <StreetTurn selectedLoads={this.props.selectedLoads} completeLoad={this.completeLoad} removeExtraLeg={this.removeExtraLeg}/>                       
                      </React.Fragment>

                    )}
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.streetTurn && (
                      <div className="">
                        <h4 className="tre d-flex flex-wrap mt-2 mb-2">
                          Assigned Street Turn{" "}
                          <span className="badge mt-1 badge-info badge-rounded text-uppercase font-medium">
                            {this.props.selectedLoads.streetTurn}
                          </span>
                        </h4>
                        <button className="btn btn-danger btn-sm btn-block" onClick={()=>this.removeStreetTurn(this.props.selectedLoads.reference_number,this.props.selectedLoads.streetTurn)}>Remove Street Turn</button>
                      </div>
                    )}
                  {this.props.selectedLoads &&
                    this.props.selectedLoads.bobTail && (
                      <div className="">
                        <h4 className="tre">
                          BobTail
                          {this.props.selectedLoads.bobTail &&
                            this.props.selectedLoads.bobTail.driver && (
                              <span className="badge badge-info badge-rounded text-uppercase font-medium">{` ${this.props.selectedLoads.bobTail.driver.name} ${this.props.selectedLoads.bobTail.driver.lastName}`}</span>
                            )}
                        </h4>
                      </div>
                    )}
                </div>
                <div className="hr-light"></div>
                <div className="form-group px-10">
                  <label className="mb-15">More Options</label>
                  <div>
                    <div className="custom-control custom-checkbox mb-2">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="isPrePullCharge"
                        checked={this.state.isPrePullCharge}
                        value={1}
                        onChange={(e) => {
                          this.setState({ isPrePullCharge: e.target.checked }, ()=>this.handleOrderStatusChange("update"));                          
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="isPrePullCharge"
                      >
                        Add Pre Pull Charge
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox mb-2">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="isNextContainerNeedToPickup"
                        name="isNextContainerNeedToPickup"
                        checked={this.state.isNextContainerNeedToPickup}
                        value={1}
                        onChange={(e) => {
                          this.setState({
                            isNextContainerNeedToPickup: e.target.checked,
                          }, ()=>this.handleOrderStatusChange("update"));                          
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="isNextContainerNeedToPickup"
                      >
                        Driver Select Container
                      </label>
                    </div>
                    {isHook && 
                      <div className="custom-control custom-checkbox mb-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="isGrayPool"
                          name="isGrayPool"
                          checked={this.state.isGrayPool}
                          value={1}
                          onChange={(e) => {
                            this.preSetOrderStatusUpdate(e.target.checked);                            
                          }}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="isGrayPool"
                        >
                          Gray Pool
                        </label>
                      </div>
                    }
                  </div>
                </div>
                <div className="p-10 moreinfo-card">
                  {!isCompleted && (
                    <button
                      className="btn btn-outline-error-100 btn-block"
                      disabled={!disabled || isCompleted}
                      onClick={() => this.completeLoad()}
                    >
                      Complete Load
                    </button>
                  )}
                  {["COMPLETED", "UNAPPROVED"].indexOf(
                    this.props.selectedLoads.status
                  ) > -1 && (
                    <React.Fragment>
                      <span className="text-dark font-weight-500 mr-3">
                        Load Completed Date
                      </span>
                      <div className="input-wrapper outline-btn-success mt-1 mb-10">
                        <div className="btn-outline-success-100">
                          <Datetime
                            className="w-auto"
                            dateFormat="MM-DD-YYYY"
                            timeFormat={this.userTimeFormat ? this.userTimeFormat : true }
                            inputProps={{
                              placeholder: "Load Completed Date",
                            }}
                            displayTimeZone={getStorage("timeZone")}
                            onChange={(date) =>
                              this.setState({ loadCompletedAt : moment(date).toISOString()})
                            }
                            value={ 
                              this.state.loadCompletedAt ? moment(this.state.loadCompletedAt) : ""
                            }
                            closeOnSelect={true}
                          />
                          <div
                            className="input-icon"
                            onClick={() => this.changeLoadCompletedDate()}
                          >
                            <IconCheck />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-outline-error-100 btn-block"
                        onClick={() => this.uncompleteLoad()}
                      >
                        Uncomplete Load
                      </button>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="col">
              {this.state.isLoading && <LoaderBar />}

              {driverLegs.length > 0 &&
                driverLegs.map((leg, legIndex) => {
                  let legColor = legIndex % 2 == 0 ? "blue" : "pink";
                 
                  let firstStatus = leg.find((status) => !status.isVoidOut );
                  let currentLegIndex = leg.findIndex((status) => !status.isVoidOut );
                  if (!firstStatus) firstStatus = leg[0];
                  const dIndex = legIndexes[legIndex];
                  if(this.state.driverOrder[dIndex] && this.state.driverOrder[dIndex].isGrayPool) legColor = 'gray'
                  if (leg.length > 0) {
                    return (
                      <div className="card card-blue mb-10">                         
                          {this.state.driverOrder[dIndex].isGrayPool && 
                            <div className="bg-gray-700 d-flex align-items-center p-10 rounded-top-left rounded-top-right">
                              <span className="text-white">
                                <IconPool className="text-white" />
                              </span>
                              <h5 className="font-16 text-white ml-10 mb-0">
                                Gray Pool
                              </h5>
                            </div>
                          }
                          <div className="p-15">
                            <div className="row mb-0 align-items-center">
                              <span>
                                <div
                                  className={`avatar-circle card-${legColor}__avatar text-white mx-10`}
                                >
                                  <div className="avatar-title">{legIndex + 1}</div>
                                </div>
                              </span>
                              <div className="col-3 p-0">
                                <Select
                                  options={this.getDrivers(selectedLoad, dIndex)
                                    .filter((dd) => !dd.isDeleted && !dd.isBlocked)
                                    .map((d) => d)}
                                  value={
                                    firstStatus.driver
                                      ? {
                                          label: `${firstStatus.driver.name} ${
                                            firstStatus.driver.lastName || ""
                                          }`.trim(),
                                          value: firstStatus.driver._id,
                                        }
                                      : null
                                  }
                                  onChange={(value) =>
                                    {
                                      this.assignDriver(value, dIndex);                                                                                                                                             
                                    }                                    
                                  }
                                  placeholder="Select Driver"
                                  className="w-100"
                                  isDisabled={
                                    firstStatus.isVoidOut ||
                                    firstStatus.arrived  ||
                                    isCompleted 
                                    // this.disabledDriver
                                  }
                                  isClearable
                                  styles={smallSelectStyle}
                                />
                              </div>
                            
                              <div className="col-3 p-0">
                                <div
                                  className="form-group mb-0 col"
                                  style={{ maxWidth: 200 }}
                                >
                                  <div className="input-wrapper" >
                                    <div>
                                      <Datetime
                                        className="w-auto"
                                        dateFormat="MM-DD-YY"
                                        timeFormat={this.userTimeFormat ? this.userTimeFormat : true }
                                        inputProps={{
                                          disabled:
                                          leg[0] && leg[0].isVoidOut || isCompleted,
                                          placeholder: "Load Assigned Date",
                                        }}
                                        displayTimeZone={getStorage(
                                          "timeZone"
                                        )}
                                        onChange={(date) =>{
                                          this.changeLoadAssignedDate(
                                            dIndex + 0,
                                            date
                                          );
                                        }                                          
                                        }
                                        onBlur={()=>this.handleOrderStatusChange("update")}
                                        value={
                                          leg[0] && leg[0].loadAssignedDate
                                            ? moment(
                                              leg[0] && leg[0].loadAssignedDate
                                              )
                                            : ""
                                        }
                                        closeOnSelect={true}
                                      />
                                    </div>
                                    <span className="input-icon">
                                      {leg[0] && leg[0].loadAssignedDate &&
                                      !leg[0] && leg[0].isVoidOut ? (
                                        <span
                                          onClick={() =>
                                            this.changeLoadAssignedDate(
                                              dIndex + 0
                                            )
                                          }
                                        >
                                          <IconTimes />
                                        </span>
                                      ) : (
                                        <IconCalendar />
                                      )}
                                    </span>
                                    <div></div>
                                  </div>
                                </div> 
                              </div>
                            
                              <div className="ml-auto mr-3 d-flex">
                                <div className="form-check mr-20">
                                  {this.state.driverOrder[dIndex].isBobtail ? <a
                                  href="#" className="btn btn-outline-light"
                                  onClick={(e) =>  this.assignBobtail(false,currentLegIndex + dIndex,this.state.driverOrder[dIndex])}
                                  >
                                  <IconCheck className="mr-2" />
                                  Bobtail
                                  </a> : <a 
                                  href="#" className="btn btn-outline-light"
                                
                                  onClick={(e) =>  this.assignBobtail(true,currentLegIndex + dIndex,this.state.driverOrder[dIndex])}
                                  >
                                  <IconPlus className="mr-2" />
                                  Add Bobtail
                                  </a>}
                                  {/* <input
                                    type="checkbox"
                                    name="active"
                                    id="isBobtail"
                                    className="form-check-input"
                                    checked={firstStatus.isBobtail}
                                    onChange={(e) => {
                                      this.assignBobtail(e.target.checked,currentLegIndex + dIndex)
                                    }}
                                  />
                                  <label className="mb-0 ml-2">
                                    Bobtail
                                  </label> */}
                                </div>
                                <div>
                                {(this.state.officeNote[dIndex] || this.state.driverNote[dIndex])  ? 
                                  <a
                                    href="#" className="btn btn-outline-light"
                                    data-tip
                                    data-for="notes"
                                    onClick={() => {
                                      this.props.showNotesModel && this.props.showNotesModel()
                                      this.props.changeTopTab("notes")
                                    }}
                                  >
                                    <IconNotes />
                                    <ReactTooltip
                                      place="top"
                                      effect="solid"
                                      id="notes"
                                      ref={(el) => (this.tooltip = el)}
                                    >
                                      <span>View in "Notes" tab Click to open</span>
                                    </ReactTooltip>
                                  </a>
                                :
                                <a
                                  href="#" className="btn btn-outline-light"
                                  onClick={() => {
                                    this.setState({ showNote: true })
                                  }}
                                >
                                  <IconPlus className="mr-2" />
                                  Add Note
                                </a>
                                }
                                
                                </div>
                              </div>
                            </div>
                            {this.state.driverOrder[dIndex].isGrayPool && 
                              <div className="mb-0 mt-3 mr-10 ml-10">
                                <div className="form-row bg-warning-50 p-10">
                                  <div className="d-flex align-items-center mr-3">
                                      <h6 className="m-0 font-12 font-medium">Gray Container #</h6>                                
                                      <form className="ml-10 w-200">
                                        <div className="form-group m-0">
                                          <div className="input-wrapper ">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Container"
                                              name="grayContainerNo" 
                                              value={this.state.grayContainerNo
                                                ? this.state.grayContainerNo 
                                                : ''
                                              } 
                                              onChange={(e) => {
                                                this.setState({ grayContainerNo: e.target.value });                                                
                                              }}
                                              onKeyDown={(e) => {
                                                this.handleKeyDown(e);                                             
                                              }}
                                              onBlur={()=>{this.handleOrderStatusChange("update")}}                        
                                            />
                                            {(this.props.selectedLoads.grayContainerNo || this.state.grayContainerNo) && (
                                              <div className="input-icon">
                                                <span onClick={(e) => { this.onRemovePress(null, { name: "grayContainerNo" }); }}>
                                                  <IconTimes />
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </form>                              
                                  </div>
                                  <div className="d-flex align-items-center mt-xs-1">
                                      <h6 className="m-0 font-12 font-medium">Gray Chassis #</h6>                                
                                      <form className="ml-10">
                                        <div className="form-group m-0">
                                          <AsyncCreatableSelect
                                            menuPlacement="auto"
                                            placeholder="Select.."
                                            className="w-200"
                                            defaultOptions={this.props.chassis.map((chassis) => ({
                                              label: chassis.chassisNo,
                                              value: chassis._id,
                                              allInfos: chassis,
                                            }))}
                                            cacheOptions
                                            loadOptions={this.getChassis}
                                            isClearable
                                            formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                            value={
                                              this.state.grayChassisNo ? 
                                                { label: this.state.grayChassisNo, value: this.state.grayChassisNo }
                                              : null
                                            }
                                            onChange={(value) => {
                                              if(value){
                                                this.grayChassisUpdate(value)
                                              }else {
                                                this.onRemovePress(null, { name: "grayChassisNo" });
                                              }
                                            }}
                                            onCreateOption={(value) =>{
                                              this.setState({"grayChassisNo": value})}
                                            }
                                            onKeyDown={(e) => this.handleKeyDown(e)}
                                            onBlur={()=> this.handleOrderStatusChange("update") }
                                            styles={smallSelectStyle}
                                          />
                                        </div>
                                      </form>                              
                                  </div>
                                </div>
                              </div>
                            }
                            <div
                              className={`form-row pb-3 align-items-end`}
                              key={100}
                              onDrop={(e) => {
                                if (legIndex === 0) {
                                  this.handleOnDrop(e);
                                }
                              }}
                              onDragOver={(e) => {
                                if (legIndex === 0) {
                                  this.handleDragOver(e);
                                }
                              }}
                              onDragEnter={() => {
                                if (legIndex === 0) {
                                  this.handleDragEnter(100);
                                }
                              }}
                            >
                              {this.state.droppedIndex === 100 && (
                                <div className="col-12 kanban-card-view mt-4">
                                  <p className="text-center my-4">
                                    Drop Your Status Here
                                  </p>
                                </div>
                              )}
                            </div>
                            {leg.map((status, statusIndex) => {
                              const index = dIndex + statusIndex;
                              return (
                                <React.Fragment>
                                  <div
                                    onDrop={this.handleOnDrop}
                                    onDragOver={(e) => this.handleDragOver(e)}
                                    onDragEnter={() => {
                                      this.handleDragEnter(index);
                                    }}
                                  >
                                    <div
                                      className={`outline-card outline-card--${legColor} p-10 mb-1`}
                                    >
                                      <div className="d-flex align-items-center mb-10">
                                        {ICONS[status.type]}
                                        <span className="font-14">
                                          {status.type}
                                        </span>
                                        {/* <a href="#" className="ml-20">
                                                                        <IconPlus className="mr-2" />
                                                                        Add Note
                                                                    </a> */}
                                        <div className="d-flex ml-auto align-items-center">
                                          {status.isVoidOut && 
                                            <span class="badge bg-danger text-light mr-2">
                                              Driver: {`${status.driver.name} ${status.driver.lastName || ""}`.trim()}
                                            </span>
                                          }
                                          {status.isVoidOut && (
                                            <span class="badge bg-danger text-light">
                                              Voided Out{" "}
                                              <span
                                                className="ml-2"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  this.removePullVoid(status, index)
                                                }
                                              >
                                                <IconTimes />
                                              </span>
                                            </span>
                                          )}
                                          {status.driver &&
                                            !status.isVoidOut &&
                                            !status.arrived && (
                                              <button
                                                className="btn btn-primary btn-sm mr-2"
                                                onClick={() =>
                                                  this.updateDriverOrderById(
                                                    "arrived",
                                                    status
                                                  )
                                                }
                                                disabled={!disabled}
                                              >
                                                Enroute
                                              </button>
                                            )}
                                          {status.driver &&
                                            !status.isVoidOut &&
                                            status.arrived && (
                                              <div className="input-wrapper w-150">
                                                {/* <p className="driver-order-status-text text-primary">Enroute</p> */}
                                                <Datetime
                                                  className="mr-2 input-primary"
                                                  dateFormat="MM-DD-YY"
                                                  timeFormat={this.userTimeFormat ? this.userTimeFormat : true }
                                                  inputProps={{
                                                    disabled:
                                                      isCompleted  || !disabled,
                                                      className: 'form-control form-control-sm'
                                                  }}
                                                  displayTimeZone={getStorage(
                                                    "timeZone"
                                                  )}
                                                  onChange={(e) =>
                                                    this.changeCompletionStatus(
                                                      "arrived",
                                                      index,
                                                      e,
                                                      status._id
                                                    )
                                                  }
                                                  onBlur={()=>{
                                                    this.handleOrderStatusChange("update")                                                    
                                                  }}
                                                  value={
                                                    status.arrived
                                                      ? moment(status.arrived)
                                                      : ""
                                                  }
                                                  closeOnSelect={false}
                                                />
                                                {!isCompleted &&
                                                  (this.state
                                                    .changeCompletionDate &&
                                                  this.state.changeCompletionDate
                                                    .statusId === status._id &&
                                                  this.state.changeCompletionDate
                                                    .type === "arrived" ? (
                                                    <div
                                                      className="input-icon text-white"
                                                      onClick={() =>
                                                        this.updateDriverOrderById(
                                                          "arrived",
                                                          status
                                                        )
                                                      }
                                                    >
                                                      <IconCheck />
                                                    </div>
                                                  ) : (
                                                    <div
                                                      className="input-icon text-white"
                                                      onClick={() =>
                                                        this.removeStatusDriverOrderById(
                                                          "arrived",
                                                          status._id
                                                        )
                                                      }
                                                    >
                                                      <IconTimes />
                                                    </div>
                                                  ))}
                                              </div>
                                            )}
                                          {status.driver &&
                                            !status.isVoidOut &&
                                            !status.departed && (
                                              <button
                                                className="btn btn-success btn-sm mr-2"
                                                onClick={() =>
                                                  this.updateDriverOrderById(
                                                    "departed",
                                                    status
                                                  )
                                                }
                                                disabled={!disabled}
                                              >
                                                Arrived
                                              </button>
                                            )}
                                          {status.driver &&
                                            !status.isVoidOut &&
                                            status.departed && (
                                              <div className="input-wrapper w-150">
                                                {/* <p className="driver-order-status-text text-success">Arrived</p> */}
                                                <Datetime
                                                  className="mr-2 input-success right"
                                                  dateFormat="MM-DD-YY"
                                                  timeFormat={this.userTimeFormat ? this.userTimeFormat : true }
                                                  inputProps={{
                                                    disabled:
                                                      isCompleted || !disabled,
                                                      className: 'form-control form-control-sm'
                                                  }}
                                                  displayTimeZone={getStorage(
                                                    "timeZone"
                                                  )}
                                                  onChange={(e) =>{
                                                    this.changeCompletionStatus(
                                                      "departed",
                                                      index,
                                                      e,
                                                      status._id
                                                    );
                                                  }                                                                                                        
                                                  }
                                                  onBlur={()=>{
                                                    this.handleOrderStatusChange("update")                                                    
                                                  }}
                                                  value={
                                                    status.departed
                                                      ? moment(status.departed)
                                                      : ""
                                                  }
                                                  closeOnSelect={false}
                                                />
                                                {!isCompleted &&
                                                  (this.state
                                                    .changeCompletionDate &&
                                                  this.state.changeCompletionDate
                                                    .statusId === status._id &&
                                                  this.state.changeCompletionDate
                                                    .type === "departed" ? (
                                                    <div
                                                      className="input-icon text-white"
                                                      onClick={() =>
                                                        this.updateDriverOrderById(
                                                          "departed",
                                                          status
                                                        )
                                                      }
                                                    >
                                                      <IconCheck />
                                                    </div>
                                                  ) : (
                                                    <div
                                                      className="input-icon text-white"
                                                      onClick={() =>
                                                        this.removeStatusDriverOrderById(
                                                          "departed",
                                                          status._id
                                                        )
                                                      }
                                                    >
                                                      <IconTimes />
                                                    </div>
                                                  ))}
                                              </div>
                                            )}
                                          {status.driver &&
                                            !status.isVoidOut &&
                                            !status.departed &&
                                            ((this.state.driverOrder[index - 1] &&
                                              (this.state.driverOrder[index - 1]
                                                .isVoidOut ||
                                                this.state.driverOrder[index - 1]
                                                  .departed)) ||
                                              index === 0) && (
                                              <button
                                                className="btn btn-secondary btn-sm mr-2"
                                                onClick={() =>
                                                  this.pullVoid(status, index)
                                                }
                                                disabled={!disabled}
                                              >
                                                Void Out
                                              </button>
                                            )}
                                          {!status.isVoidOut && !status.departed && (
                                            <button
                                              className="btn btn-link text-danger"
                                              disabled={isCompleted}
                                              onClick={() =>{
                                                if(leg.length > 1){this.removeStatus(index)}
                                              }
                                              }
                                            >
                                              <IconTrash />
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                      <div className="d-flex form-row-md">
                                        <div className="form-group mb-0 col">
                                        <label>{ROUTING_LABELS[status.type]}</label>
                                          <div className="w-100">
                                            {status.type === "CHASSISPICK" && (
                                              <AsyncSelect
                                                className="w-100"
                                                isClearable
                                                defaultOptions={makeOptionsForSelect(
                                                  this.props.chassisTerms,
                                                  "company_name",
                                                  "address.address",
                                                  "_id"
                                                )}
                                                cacheOptions
                                                value={
                                                  status.customerId && {
                                                    label: `${
                                                      status.customerId.company_name
                                                    } ${
                                                      status.customerId.address
                                                        ? status.customerId.address
                                                            .address
                                                        : ""
                                                    }`.trim(),
                                                    value: status.customerId._id,
                                                  }
                                                }
                                                onChange={(value) =>{
                                                  this.setCustomerToStatus(
                                                    index,
                                                    value,
                                                    status
                                                  );                                               
                                                }                                                  
                                                }
                                                loadOptions={
                                                  getChassisPickCustomersAsyncSearch
                                                }
                                                isDisabled={
                                                  status.isVoidOut || isCompleted
                                                }
                                                styles={smallSelectStyle}
                                              />
                                            )}
                                            {status.type === "PULLCONTAINER" && (
                                              <AsyncSelect
                                                className="w-100"
                                                isClearable
                                                defaultOptions={makeOptionsForSelect(
                                                  this.props.shippersOptions,
                                                  "company_name",
                                                  "address.address",
                                                  "_id"
                                                )}
                                                cacheOptions
                                                value={
                                                  status.customerId && {
                                                    label: `${
                                                      status.customerId.company_name
                                                    } ${
                                                      status.customerId.address
                                                        ? status.customerId.address
                                                            .address
                                                        : ""
                                                    }`.trim(),
                                                    value: status.customerId._id,
                                                  }
                                                }
                                                onChange={(value) =>
                                                  {                                            
                                                    this.setCustomerToStatus(
                                                      index,
                                                      value,
                                                      status,
                                                    );
                                                   
                                                  }
                                                }
                                                loadOptions={
                                                  getTMSshipperAsyncSearch
                                                }
                                                isDisabled={
                                                  status.isVoidOut || isCompleted
                                                }
                                                styles={smallSelectStyle}
                                              />
                                            )}
                                            {status.type === "DELIVERLOAD" && (
                                              <AsyncSelect
                                                className="w-100"
                                                isClearable
                                                defaultOptions={makeOptionsForSelect(
                                                  this.props.consigneesOptions,
                                                  "company_name",
                                                  "address.address",
                                                  "_id"
                                                )}
                                                cacheOptions
                                                value={
                                                  status.customerId && {
                                                    label: `${
                                                      status.customerId.company_name
                                                    } ${
                                                      status.customerId.address
                                                        ? status.customerId.address
                                                            .address
                                                        : ""
                                                    }`.trim(),
                                                    value: status.customerId._id,
                                                  }
                                                }
                                                onChange={(value) =>
                                                  {
                                                    this.setCustomerToStatus(
                                                    index,
                                                    value,
                                                    status
                                                  );                                              
                                                  }
                                                  
                                                }
                                                loadOptions={
                                                  getTMSconsigneeAsyncSearch
                                                }
                                                isDisabled={
                                                  status.isVoidOut || isCompleted
                                                }
                                                styles={smallSelectStyle}
                                              />
                                            )}
                                            {status.type === "RETURNCONTAINER" && (
                                              <>
                                                <AsyncSelect
                                                  className="w-100"
                                                  isClearable
                                                  defaultOptions={makeOptionsForSelect(
                                                    this.props.customers,
                                                    "company_name",
                                                    "address.address",
                                                    "_id"
                                                  )}
                                                  cacheOptions
                                                  value={
                                                    status.customerId && {
                                                      label: `${
                                                        status.customerId.company_name
                                                      } ${
                                                        status.customerId.address
                                                          ? status.customerId.address
                                                              .address
                                                          : ""
                                                      }`.trim(),
                                                      value: status.customerId._id,
                                                    }
                                                  }
                                                  onChange={(value) =>
                                                    this.setCustomerToStatus(
                                                      index,
                                                      value,
                                                      status
                                                    )
                                                  }
                                                  loadOptions={
                                                    getEmptyOriginCustomersAsyncSearch
                                                  }
                                                  isDisabled={
                                                    status.isVoidOut || isCompleted
                                                  }
                                                  styles={smallSelectStyle}
                                                />
                                                 {/* Recommended Return Terminals */}
                                                 {this.props.isEmptyEnabled && <RecommendedReturnTerminals  row={this.props.selectedLoads} isLoadInfo={true}/>}
                                              </>
                                              
                                            )}
                                            {(status.type === "DROPCONTAINER" ||
                                              status.type === "HOOKCONTAINER") && (
                                              <AsyncSelect
                                                className="w-100"
                                                isClearable
                                                defaultOptions={makeOptionsForSelect(
                                                  this.props.customers,
                                                  "company_name",
                                                  "address.address",
                                                  "_id"
                                                )}
                                                cacheOptions
                                                value={
                                                  status.customerId && {
                                                    label: `${
                                                      status.customerId.company_name
                                                    } ${
                                                      status.customerId.address
                                                        ? status.customerId.address
                                                            .address
                                                        : ""
                                                    }`.trim(),
                                                    value: status.customerId._id,
                                                  }
                                                }
                                                onChange={(value) =>
                                                  {
                                                    this.setCustomerToStatus(
                                                      index,
                                                      value,
                                                      status
                                                    );                                                 
                                                  }                                                  
                                                }
                                                loadOptions={
                                                  getDroppedCustomersAsyncSearch
                                                }
                                                isDisabled={
                                                  status.isVoidOut || isCompleted
                                                }
                                                styles={smallSelectStyle}
                                              />
                                            )}
                                            {status.type ===
                                              "CHASSISTERMINATION" && (
                                              <AsyncSelect
                                                className="w-100"
                                                isClearable
                                                defaultOptions={makeOptionsForSelect(
                                                  this.props.chassisTerms,
                                                  "company_name",
                                                  "address.address",
                                                  "_id"
                                                )}
                                                cacheOptions
                                                value={
                                                  status.customerId && {
                                                    label: `${
                                                      status.customerId.company_name
                                                    } ${
                                                      status.customerId.address
                                                        ? status.customerId.address
                                                            .address
                                                        : ""
                                                    }`.trim(),
                                                    value: status.customerId._id,
                                                  }
                                                }
                                                onChange={(value) =>{
                                                  this.setCustomerToStatus(
                                                    index,
                                                    value,
                                                    status
                                                  );
                                                }
                                                }
                                                loadOptions={
                                                  getChassisTerminationCustomersAsyncSearch
                                                }
                                                isDisabled={
                                                  status.isVoidOut || isCompleted
                                                }
                                                styles={smallSelectStyle}
                                              />
                                            )}
                                          </div>
                                        </div>
                                        
                                      </div>
                                    </div>
                                    {this.state.droppedIndex === index && (
                                      <div className="col-12 kanban-card-view my-2">
                                        <p className="text-center my-4">
                                          Drop Your Status Here
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                      </div>
                    );
                  }
                })}

              {this.state.allowDriverCompletion && (
                <div className="card p-15 card-blue mb-10">
                  <div
                    className={`outline-card outline-card--blue p-10 mb-1`}
                    key={"driverCompletion"}
                  >
                    <div className="d-flex align-items-center mb-10">
                      {ICONS.COMPLETED}
                      <span className="font-14">Completed</span>
                      <div className="d-flex ml-auto">
                        {loadCompletedAt && (
                          <Datetime
                            className="mr-2 input-primary"
                            dateFormat="MM-DD-YY"
                            timeFormat={this.userTimeFormat ? this.userTimeFormat : true }
                            inputProps={{ disabled: isCompleted }}
                            displayTimeZone={getStorage("timeZone")}
                            value={moment(loadCompletedAt)}
                          />
                        )}
                        {!isCompleted && (
                          <button
                            className="btn btn-link text-danger"
                            onClick={() =>{
                              this.setState({ allowDriverCompletion: false },
                                this.handleOrderStatusChange("update")
                              );                              
                            }
                            }
                          >
                            <IconTrash />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {this.state.showNote && <Modal show={this.state.showNote} bsSize="sm" animation={false}>
          <Modal.Header>
            <h5 className="modal-title" id="showModal">
              Notes
            </h5>
          </Modal.Header>
          <Modal.Body>
            <ul
              className="nav nav-compact w-100 text-center"
              role="tablist"
            >
              <li className="nav-item w-50">
                {" "}
                <a
                    className={`nav-link ${this.state.activeNoteTab == "load" ? "active"  : ''}  mr-1`}
                  data-toggle="tab"
                  href="#note"
                  role="tab"
                  onClick={() => this.setState({ activeNoteTab: "load" })}
                >
                  <span className="hidden-xs-down">Load</span>
                </a>{" "}
              </li>
              <li className="nav-item w-50">
                {" "}
                <a
                  className={`nav-link ${this.state.activeNoteTab == "driver" ? "active"  : ''}  mr-1`}
                  data-toggle="tab"
                  href="#note"
                  role="tab"
                  onClick={() => this.setState({ activeNoteTab: "driver" })}
                >
                  <span className="hidden-xs-down">Driver</span>
                </a>{" "}
              </li>
            </ul>

            <form className="mt-3">
              <div className="form-group">
                <textarea
                  disabled={this.state.loading}
                  className="form-control"
                  name={
                    this.state.activeNoteTab === "load"
                      ? "officeNote"
                      : "driverNote"
                  }
                  rows={7}
                  placeholder={`Write notes for the ${this.state.activeNoteTab === "load"
                  ? "load"
                  : "driver"} here..`}
                  value={
                    this.state.activeNoteTab === "load"
                      ? this.state.officeNote
                      : this.state.driverNote
                  }
                  onChange={(e) => {
                    this.setState({ [e.target.name]: e.target.value });
                  }}
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ showNote: false, officeNote: "", driverNote: "" })}
              className="btn btn-close"
            >
              Close
            </button>
            <button
              disabled={this.state.loading}
              onClick={() => this.submitNotes()}
              className="btn btn-primary"
              value="Save"
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>}
      </React.Fragment>
    );
  }
  render() {
    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser) {
      if (loggedInUser.role === "carrier" || loggedInUser.role === "customer" ||loggedInUser.role === "fleetcustomer") {
        return this.renderReturn();
      } else if (loggedInUser.permissions.length !== 0) {
        if (loggedInUser.permissions.includes("customer_service_order_status")){ 
          return this.renderReturn();
        }
        else {return <div className="nopermission"><h1>You do not have permission to view this page</h1></div>}
      }

      else {return <div className="nopermission"><h1>You do not have permission to view this page</h1></div>;}
    }
    // return this.renderReturn();
  }
}
function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...actionCreators, hardRemoveDriver }, dispatch) };
}

function mapStateToProps(state) {
  return {
    driverList: state.TmsReducer.drivers,
    customers: state.TmsReducer.customers,
    shippersOptions: state.TmsReducer.shippers,
    consigneesOptions: state.TmsReducer.consignees,
    callers: state.TmsReducer.callers,
    allCustomers: state.TmsReducer.allCustomers,
    chassisTerms: state.TmsReducer.chassisTerms,
    chassis: state.chassisReducer.chassis,
    isEmptyEnabled: state.TmsReducer.isEmptyEnabled
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadDriverOrder);